import { format, isValid } from 'date-fns';
import React, { useState } from 'react';

import styled from '@emotion/styled';

import StatusCell from '../../../../components/Badge/StatusCell';
import { Modal } from '../../../../components/Modal/Modal';
import RegenerateThirdPartyTokenModal from '../../../../components/Modal/ModalActions/RegenerateThirdPartyTokenModal/RegenerateThirdPartyTokenModal';
import { ThirdPartyAccessInterface } from '../../../../models/dashboard/settings/third-party-access.model';

interface CellProps {
  data?: Record<string, any>;
}

export const ExpiryDateCell: React.FC<CellProps> = ({ data }) => {
  const date = new Date(data?.expiresAt);
  return <div>{isValid(date) ? format(date, 'MMM dd, yyyy') : 'N/A'}</div>;
};

// Wrapped so the grid cell keeps its padding and the badge keeps its own
export const StatusBadgeCell: React.FC<CellProps> = ({ data }) => (
  <div>
    <StatusCell
      data={data}
      statusKey='status'
      customClasses='small-border-radius'
    />
  </div>
);

export const RegenerateTokenCell: React.FC<CellProps> = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const isExpired = data?.status === 'Expired';

  return (
    <div>
      <RegenerateBtn
        type='button'
        disabled={isExpired}
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(true);
        }}
      >
        Regenerate Token
      </RegenerateBtn>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <RegenerateThirdPartyTokenModal
          data={data as ThirdPartyAccessInterface}
        />
      </Modal>
    </div>
  );
};

const RegenerateBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: none;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.blueColor};
  cursor: pointer;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    color: ${({ theme }) => theme.palette.grayTextColor};
    cursor: not-allowed;
  }
`;
